module.exports = __webpack_public_path__ + "static/img/scfk.0e889853.svg";